// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import interpellationFollowUpEntity from './entities/interpellation-follow-up.json';
import interpellationFollowUpMenu from '../pages/interpellation-follow-up/menu.json';
import interpellationFollowUpFullForm from '../pages/interpellation-follow-up/forms/full.json';
import interpellationFollowUpContextForm from '../pages/interpellation-follow-up/forms/context.json';
import interpellationFollowUpMiniForm from '../pages/interpellation-follow-up/forms/mini.json';
import interpellationFollowUpLookupForm from '../pages/interpellation-follow-up/forms/lookup.json';
import interpellationFollowUpTableView from '../pages/interpellation-follow-up/views/table.json';
import interpellationFollowUpCardsView from '../pages/interpellation-follow-up/views/cards.json';
import interpellationFollowUpCalendarView from '../pages/interpellation-follow-up/views/calendar.json';
import interpellationFollowUpDashboardView from '../pages/interpellation-follow-up/views/dashboard.json';

/** Тип запису «Подальші дії» зі сторінками пакета: меню, форми та подання з pages/interpellation-follow-up/. */
export const interpellationFollowUpDefinition: IRecordTypeDefinition = {
  ...interpellationFollowUpEntity,
  views: assembleViewSet({
      table: interpellationFollowUpTableView,
      cards: interpellationFollowUpCardsView,
      calendar: interpellationFollowUpCalendarView,
      dashboard: interpellationFollowUpDashboardView,
  }),
  form: interpellationFollowUpFullForm,
  forms: { full: interpellationFollowUpFullForm, context: interpellationFollowUpContextForm, mini: interpellationFollowUpMiniForm, lookup: interpellationFollowUpLookupForm },
  menu: interpellationFollowUpMenu,
} as IRecordTypeDefinition;
